import React from 'react';
import { RetailerPatchMutation } from '../graphql/mutations/RetailerPatchMutation';
import { RetailerEditQuery } from '../graphql/query/RetailerEditQuery';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/Retailer.json';
import inputTypeIntro from '../static/introspection/RetailerPatchInput.json';
import { ENTITY } from '../utils/entities';
import { graphqlQuery } from '../utils/graphql';
import { UserData } from '@food/auth';

export const RetailerEdit = ({ id }) => (
	<UserData>
		{({ isInternal }) => (
			<EntityEditFetcher
				fetcher={graphqlQuery(RetailerEditQuery, { id })}
				mutation={RetailerPatchMutation}
				entityName={ENTITY.RETAILER}
				typeIntro={typeIntro}
				inputTypeIntro={inputTypeIntro}
				id={id}
				fields={[
					isInternal ? 'sfId' : null,
					'name',
					'logoMedia',
					'description',
					'descriptionIta',
					'descriptionLong',
					'descriptionLongIta',
					'pecEmail',
					'vatNumber',
					'website',
					'Country',
					'StateProvince',
					'postalCode',
					'city',
					'address1',
					'address2',
					'lat',
					'lng',
				]}
			/>
		)}
	</UserData>
);
